import { render, staticRenderFns } from "./AssayTypes.vue?vue&type=template&id=a7880714&"
import script from "./AssayTypes.vue?vue&type=script&lang=js&"
export * from "./AssayTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports